import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { auth } from '@/api/auth'
import { BASE_URL } from '@/api/api'

class CaseAttachmentService extends AttachmentResource {
    async addAttachment(laboratoryId, caseId, attachmentTypeId, file, thumbnailBytes) {
        let thumbnail

        if (thumbnailBytes) {
            thumbnail = this.base64ToBlob(thumbnailBytes, file.name)
        } else {
            let generatedThumbnailBytes = await this.thumbnailifyFromBlob(file)
            thumbnail = this.base64ToBlob(generatedThumbnailBytes, file.name)
        }

        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('atyId', attachmentTypeId)

        if (thumbnail) {
            formData.append('thumbnail', thumbnail, file.name)
        }

        const response = await this.axios.post(
            `/common/laboratories/${laboratoryId}/cases/${caseId}/attachments`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }

    async getAttachments(laboratoryId, caseId, attachmentTypeId) {
        const params = { attachmentTypeId }
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/attachments`, { params })
        return response.data
    }

    async patchAttachment(laboratoryId, caseId, attachmentId, request) {
        const response = await this.axios.patch(`/common/laboratories/${laboratoryId}/cases/${caseId}/attachments/${attachmentId}`, request)
        return response.data
    }

    async getAttachmentsForAttachmentType(laboratoryId, caseId, attachmentTypeId) {
        const params = { attachmentTypeId }
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/attachments`, { params })
        return response.data
    }

    async getFile(laboratoryId, caseId, attachmentId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/attachments/${attachmentId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }

    getUrlFile(laboratoryId, caseId, attachmentId) {
        return `${BASE_URL}/common/laboratories/${laboratoryId}/cases/${caseId}/attachments/${attachmentId}?authenticationToken=${auth.token}`
    }

    getUrlForAttachment(laboratoryId, caseId, attachmentId) {
        return this.getUrlFile(laboratoryId, caseId, attachmentId)
    }

    async deleteAttachment(laboratoryId, caseId, attachmentId) {
        const response = await this.axios.delete(`/common/laboratories/${laboratoryId}/cases/${caseId}/attachments/${attachmentId}`)
        return response.data
    }
}

export default new CaseAttachmentService()
